import { render, staticRenderFns } from "./UserLabel.vue?vue&type=template&id=13d8c62f&scoped=true"
import script from "./UserLabel.vue?vue&type=script&lang=js"
export * from "./UserLabel.vue?vue&type=script&lang=js"
import style0 from "./UserLabel.vue?vue&type=style&index=0&id=13d8c62f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8c62f",
  null
  
)

export default component.exports